var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1261161561"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3923",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "matrix(-1 0 0 1 36 0)",
    fill: "#2D2924"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1261161559"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 36C21.5601 36 25.0402 34.9443 28.0003 32.9665C30.9603 30.9886 33.2675 28.1774 34.6298 24.8883C35.9922 21.5992 36.3487 17.98 35.6541 14.4884C34.9596 10.9967 33.2453 7.78943 30.7279 5.27209C28.2106 2.75474 25.0033 1.04041 21.5116 0.345872C18.02 -0.348662 14.4008 0.00780229 11.1117 1.37018C7.82263 2.73256 5.01143 5.03967 3.03356 7.99975C1.0557 10.9598 0 14.4399 0 18C0.00515747 22.7723 1.90324 27.3477 5.27777 30.7222C8.65231 34.0968 13.2277 35.9948 18 36ZM18 0.92825C21.3765 0.92825 24.6771 1.92949 27.4846 3.80536C30.292 5.68122 32.4801 8.34746 33.7722 11.4669C35.0644 14.5864 35.4024 18.0189 34.7437 21.3305C34.085 24.6421 32.4591 27.684 30.0716 30.0716C27.684 32.4591 24.6421 34.085 21.3305 34.7437C18.0189 35.4025 14.5864 35.0644 11.4669 33.7722C8.34747 32.4801 5.68123 30.292 3.80536 27.4846C1.92949 24.6771 0.928253 21.3765 0.928253 18C0.933407 13.4739 2.73368 9.1346 5.93414 5.93414C9.1346 2.73368 13.4739 0.933404 18 0.92825Z",
    fill: "#C3FCF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.32856 17.9981L22.3329 7.05078L15.6957 17.9981L22.3329 28.9422L7.32856 17.9981Z",
    fill: "#C3FCF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.1401 21.5531C23.1773 21.5531 21.5861 19.962 21.5861 17.9992C21.5861 16.0364 23.1773 14.4453 25.1401 14.4453C27.1028 14.4453 28.694 16.0364 28.694 17.9992C28.694 19.962 27.1028 21.5531 25.1401 21.5531Z",
    fill: "#C3FCF2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1401 21.5507C24.1984 21.5507 23.2952 21.1766 22.6294 20.5107C21.9635 19.8448 21.5894 18.9417 21.5894 18H28.694C28.694 18.4666 28.602 18.9285 28.4234 19.3595C28.2447 19.7905 27.9829 20.1821 27.6529 20.5119C27.3228 20.8416 26.931 21.1031 26.4998 21.2813C26.0687 21.4596 25.6066 21.5511 25.1401 21.5507Z",
    fill: "#00C9B0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3329 28.9441L7.32856 18H15.6957L22.3329 28.9441Z",
    fill: "#00C9B0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevArrow);
export default __webpack_public_path__ + "static/media/prevArrow.8998d66a9b58291580c6c9a06e84d8f8.svg";
export { ForwardRef as ReactComponent };